import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../services/user.service';
import { PreviousRouteServiceService } from '../services/previous-route-service.service';

import { TranslateService } from '@ngx-translate/core';
import { ModalProfileComponent } from '../modal-profile/modal-profile.component';
import { ToastrService } from 'ngx-toastr';

import { MatPaginator, MatPaginatorIntl, MatSort } from '@angular/material';
import { NotificationsService } from '../services/notifications.service';
import { ModalNotificationComponent } from '../modal-notification/modal-notification.component';
import { INotification } from '../interfaces/notification';

import { fromEvent, merge, of as observableOf } from 'rxjs';
import { catchError, map, startWith, switchMap, tap } from 'rxjs/operators';
import { INotificationSearchParam } from '../interfaces/notification-search-param';
import { SelectionModel } from '@angular/cdk/collections';
import { ILoggedUser } from '../interfaces/loggedUser';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {

  currentUser: ILoggedUser;
  oldLocal = localStorage.getItem('localUser');

  itemLocal = JSON.parse(this.oldLocal);
  UserName = this.itemLocal.userName;

  logoImage: any = require("../image/logo/Amodto_Trasparent.png");
  previousRoute: string;

  resultsLength = 0;
  isLoadingResults = true;
  notifications: Array<INotification>;
  searchParam: INotificationSearchParam;

  initialSelection = [];
  allowMultiSelect = true;
  selection = new SelectionModel<INotification>(this.allowMultiSelect, this.initialSelection);

  displayedColumns: string[] = ['select', 'Data', 'Mittente', 'Testo', 'Letto', 'Stato'];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('inputFilter') inputFilter: ElementRef;

  constructor(
    private modalService: NgbModal,
    private translate: TranslateService,
    private toastr: ToastrService,
    private userService: UserService,
    private router: Router,
    private previousRouteService: PreviousRouteServiceService,
    private MatPaginatorText: MatPaginatorIntl,
    private notificationService: NotificationsService,
    private sanitizer: DomSanitizer
  ) { }


  ngOnInit() {
    this.translate.use(localStorage.getItem('localLanguage'));
    this.getUser();

    this.searchParam = {
      Value: "",
      PageLength: 10,
      CurrentPage: 0,
      Draw: 0,
      OrderValue: 0,
      OrderType: "desc",
      ViewDeleted: true
    }

    this.MatPaginatorText.nextPageLabel = 'Avanti';
    this.MatPaginatorText.previousPageLabel = 'Indietro';
    this.MatPaginatorText.firstPageLabel = 'Prima pagina';
    this.MatPaginatorText.lastPageLabel = 'Ultima pagina';
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page, fromEvent(this.inputFilter.nativeElement, 'keyup').pipe(tap(() => this.paginator.pageIndex = 0)))
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          this.selection.clear()

          this.searchParam.Value = this.inputFilter.nativeElement.value.trim().toLowerCase();
          this.searchParam.CurrentPage = this.paginator.pageIndex * this.searchParam.PageLength;
          if (this.sort.direction) this.searchParam.OrderType = this.sort.direction;
          this.searchParam.OrderValue = (this.sort.active == "Mittente") ? 1 : 0;

          return this.notificationService.notifyList(this.searchParam);
        }),
        map(json => {
          this.isLoadingResults = false;
          this.resultsLength = json.recordsTotal;
          return json.data;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          this.toastr.error("Error", null, {
            positionClass: 'toast-top-center',
            timeOut: 2000
          })
          return observableOf([]);
        })
      ).subscribe(data => this.notifications = data);
  }

  //Api return Current User
  getUser() {
    this.userService.getUsers(this.UserName).subscribe((data: any) => {
      this.currentUser = data;
      if (this.currentUser.ProfileImg) {
        this.userService.downloadImgProfile(this.currentUser.Id).subscribe(res => {
          this.currentUser.ProfileImgURL = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + res);
        });
      } else this.currentUser.ProfileImgURL = '../../assets/image/Profile.png';
    })
  }


  openModalProfile(content) {
    const modalRef = this.modalService.open(ModalProfileComponent, { centered: true });
    modalRef.componentInstance.userLogged = this.currentUser;
  }

  LogOut() {
    localStorage.removeItem('localUser');
    localStorage.removeItem('localLanguage');
    localStorage.removeItem('localModules');
    localStorage.removeItem('localFacilities');
    localStorage.removeItem('localID');
    localStorage.removeItem('localTags');
    localStorage.removeItem('localIDElaboration');
    localStorage.removeItem('localStateAnalysis');
    localStorage.removeItem('localSurveyCompiled');
    this.router.navigate(['/']);
  }

  openNotification(notification) {
    const modalRef = this.modalService.open(ModalNotificationComponent, { centered: true });
    modalRef.componentInstance.notification = notification;
  }

  comeBack() {
    this.previousRoute = this.previousRouteService.getPreviousUrl();
    if (this.previousRoute != '/notifications') {
      this.router.navigate([this.previousRoute]);
    }
    else {
      this.router.navigate(['/home']);
    }
  }

  markAll(asRead: boolean) {
    var selected = this.selection.selected.map(notification => notification.Id);
    var callService$ = asRead ? this.notificationService.markAsRead(selected) : this.notificationService.markAsUnRead(selected);
    callService$.subscribe((data) => {
      this.selection.selected.forEach(notification => {
        notification.IsRead = asRead;
      });
      this.toastr.success(`${this.selection.selected.length} ${data}`, null, {
        positionClass: 'toast-top-right',
        timeOut: 2000
      })
    }, error => {
      this.toastr.error("Error", null, {
        positionClass: 'toast-top-right',
        timeOut: 2000
      })
    });
  }


  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.notifications.length;
    return numSelected == numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.notifications.forEach(row => this.selection.select(row));
  }
}
